import type { WaterPhaseVolumeFactorBwCalculator } from "../d";
export const waterPhaseVolumeFactorBwCalculator: WaterPhaseVolumeFactorBwCalculator =
  params => {
    const { temperatureF, inSituPressurePSIA, waterSpecificGravity } = params;

    const I6 = calculateI6(waterSpecificGravity);

    const I7 = calculateI7(inSituPressurePSIA, temperatureF);

    const I8 = calculateI8(inSituPressurePSIA, temperatureF);

    const waterVolumeFactorBBLSTB = calculateWaterVolumeFactor(
      I8,
      I7,
      temperatureF,
      I6
    );

    return {
      waterVolumeFactorBBLSTB,
      I6,
      I7,
      I8
    };
  };

// C55: =(C10-1)/(0.69510^-6)
function calculateI6(waterSpecificGravity: number): number {
  return (waterSpecificGravity - 1) / (0.695 * 1e-6);
}

// C57: =-0.000003C2+1.006+((C3-100)(-0.000003C2+1.059-(-0.000003C2+1.006)))/150
function calculateI7(inSituPressurePSIA: number, temperatureF: number): number {
  return (
    -0.000003 * inSituPressurePSIA +
    1.006 +
    ((temperatureF - 100) *
      (-0.000003 * inSituPressurePSIA +
        1.059 -
        (-0.000003 * inSituPressurePSIA + 1.006))) /
      150
  );
}

// C59: =-0.000001C2+1.006+((C3-100)(-0.000001C2+1.059-(-0.000001C2+1.006)))/150
function calculateI8(inSituPressurePSIA: number, temperatureF: number): number {
  return (
    -0.000001 * inSituPressurePSIA +
    1.006 +
    ((temperatureF - 100) *
      (-0.000001 * inSituPressurePSIA +
        1.059 -
        (-0.000001 * inSituPressurePSIA + 1.006))) /
      150
  );
}

// C61: =C59+((C59-C57)(0.0000005C3^2-0.000449C3+0.11395)*C55)/10000
function calculateWaterVolumeFactor(
  I8: number,
  I7: number,
  temperatureF: number,
  I6: number
): number {
  return (
    I8 +
    ((I8 - I7) *
      (0.0000005 * Math.pow(temperatureF, 2) -
        0.000449 * temperatureF +
        0.11395) *
      I6) /
      10000
  );
}
